import React from "react";
import axios from "axios";
import { useQuery } from "react-query";
import { Button } from "components/buttonV2";
import { useModalContext } from "components/modal";
import SpecialReportModal from "./SpecialReportModal";

type Props = {
  viewedEmployeeId: number | string;
};

// this is for luann
const SPECIAL_REPORT_COMPANY_ID = 1;
const SPECIAL_REPORT_VIEW_EMPLOYEE_ID = "100";

const SpecialReport = ({ viewedEmployeeId }: Props) => {
  const { setModal } = useModalContext();

  const { data: currentUser } = useQuery(
    ["current-user"],
    async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/eserv-business/users/current-user`
      );
      return response.data;
    },
    { retry: false }
  );

  const showButton =
    currentUser &&
    currentUser.companyId === SPECIAL_REPORT_COMPANY_ID &&
    String(viewedEmployeeId) === SPECIAL_REPORT_VIEW_EMPLOYEE_ID;

  if (!showButton) {
    return null;
  }

  return (
    <div className="flex flex-row items-center">
      <Button
        type="secondary"
        onClick={() => {
          setModal({
            component: <SpecialReportModal />,
            label: "Special Report",
          });
        }}
      >
        Special Report
      </Button>
    </div>
  );
};

export default SpecialReport;
